// extracted by mini-css-extract-plugin
export default {"container":"Presentation_container__CnYqk","intro":"Presentation_intro__nddqA","titleWrapper":"Presentation_titleWrapper__qVcD-"};